export default "__VITE_ASSET__Bb_RSJln__"